// The notes an export sends beside its file (TGCLOUD-1845). The phenopacket
// export's body IS the downloaded file, so what it could not place (a genotype
// no recorded disease fits, a free-text genotype sent as text) comes in the
// X-Export-Notes header: URI-encoded JSON, an array of sentences.
//
// Never throws: a missing or malformed header is no notes.
export function exportNotesOf(headers) {
  const raw = headers?.['x-export-notes'];
  if (!raw || typeof raw !== 'string') return [];
  try {
    const parsed = JSON.parse(decodeURIComponent(raw));
    return Array.isArray(parsed)
      ? parsed.filter((n) => typeof n === 'string' && n.trim())
      : [];
  } catch {
    return [];
  }
}
